import React, { memo, useCallback, useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MfeReactComponent as MfeReactComponentOG } from '@carvana/microfrontend-react';
import { CoreEvent, eventNames } from '@carvana/core-events';
import { equalArray } from '../../utilities/isArrayEqual';

const MfeReactComponent = memo(MfeReactComponentOG);

const FavoriteComponent = styled(MfeReactComponent)`
  margin-right: 10px !important;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin-right: 30px !important;
  }
`;

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export const Favorites = memo(props => {
  const { favorites, removeFavorite } = props;
  const prevCount = usePrevious(favorites);
  const removeFavoriteCallback = useCallback(
    ({ stockNumber }) => {
      if (stockNumber && favorites && removeFavorite) {
        removeFavorite(stockNumber);
      }
    },
    [removeFavorite]
  );

  useEffect(() => {
    if (favorites && prevCount && !equalArray(prevCount, favorites)) {
      CoreEvent.emit(eventNames.favorites.refresh);
    }
  }, [prevCount]);

  useEffect(() => {
    CoreEvent.on(eventNames.favorites.vehicle.removed, removeFavoriteCallback);

    return () => CoreEvent.off(eventNames.favorites.vehicle.removed, removeFavoriteCallback);
  }, [removeFavorite]);

  return <FavoriteComponent module="FavoritesModule" component="default" />;
});

Favorites.propTypes = {
  favorites: PropTypes.arrayOf(PropTypes.shape({})),
  removeFavorite: PropTypes.func
};
